import { AvatarImage } from "@radix-ui/react-avatar";
import { cva } from "class-variance-authority";
import { cn } from "../lib/utils";
import { Avatar, AvatarFallback, type AvatarSize } from "./avatar";

import { TooltipProvider } from "@radix-ui/react-tooltip";
import { Icon } from "./icon";
import type { TableUserData } from "./table/types";
import { TruncatedText } from "./truncated-text";

const userInfoVariants = cva("flex items-center bg-white", {
  variants: {
    size: {
      S: "max-w-[110px]",
      M: "max-w-[125px]", // still not specified in design, so keeping it to 125
      L: "max-w-[125px]", // still not specified in design, so keeping it to 125
      XL: "max-w-[125px]", // still not specified in design, so keeping it to 125
    },
  },
  defaultVariants: {
    size: "M",
  },
});

export type UserInfoProps = Partial<TableUserData> & {
  size?: AvatarSize;
  className?: string;
};

const UserInfo: React.FC<UserInfoProps> = ({
  firstName,
  lastName,
  fullName,
  avatarUrl,
  size = "M",
  className = "",
}) => {
  return (
    <TooltipProvider>
      <div className={cn(userInfoVariants({ size }), className)}>
        {firstName && lastName ? (
          <Avatar size={size} className="mr-2">
            <>
              {avatarUrl && (
                <AvatarImage src={avatarUrl} alt={`${firstName} ${lastName}`} />
              )}
              <AvatarFallback
                size={size}
                firstName={firstName}
                lastName={lastName}
              />
            </>
          </Avatar>
        ) : (
          <Icon
            icon="user"
            className="text-gray-900 mr-2"
            size={size === "S" ? 12 : size === "M" ? 24 : 32}
          />
        )}
        <TruncatedText className="font-semibold truncate">
          {fullName ? fullName : `${firstName} ${lastName}`}
        </TruncatedText>
      </div>
    </TooltipProvider>
  );
};

export { UserInfo };
